const BlogReducer = (state, action) => {
  switch (action.type) {
    case "POST_LOADING":
      return {
        ...state,
        loading: true,
        error: false,
      };
    case "CATEGORY_LOADING":
      return {
        ...state,
        categoryloading: true,
        categoryerror: false,
      };
    case "POPULARPOST_LOADING":
      return {
        ...state,
        popularpostloading: true,
        popularposterror: false,
      };

    case "GET_POST":
      let updateblogpost = [...state.blogpost];
      if (state.currentPath !== action.blogpost.path) {
        updateblogpost = [];
      }
      return {
        ...state,
        loading: false,
        blogpost: updateblogpost.concat(action.blogpost.data),
        error: false,
        currentPath: action.blogpost.path,
        images: [],
      };
    case "GET_CATEGORY":
      return {
        ...state,
        categoryloading: false,
        categoryerror: false,
        categorylist: action.categorylist,
      };
    case "GET_SINGLEPOST":
      return {
        ...state,
        loading: false,
        singlepost: action.singlepost,
        error: false,
        currentPath: "",
        images: [],
        blogpost: [],
      };
    case "GET_POPULARPOST":
      return {
        ...state,
        popularpostloading: false,
        popularpost: action.popularpost,
        popularposterror: false,
      };
    case "GET_IMAGES":
      return {
        ...state,
        loading: false,
        images: state.images.concat(action.images),
        error: false,
        blogpost: [],
      };

    case "POST_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "POPULARPOST_ERROR":
      return {
        ...state,
        popularpost: [],
        popularpostloading: false,
        popularposterror: action.popularerror,
      };
    case "CATEGORY_ERROR":
      return {
        ...state,
        categorylist: null,
        categoryloading: false,
        categoryerror: action.categoryerror,
      };

    default:
      return state;
  }
};

export default BlogReducer;
